import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { motion } from "motion/react";
import { cn } from "../../lib/utils";
import { XMarkIcon } from "@heroicons/react/24/outline";

export default function Modal({
  isModalOpen,
  onClose,
  children,
  title,
  description,
  confirmClose = false,
  className,
  dialogClassName,
  dataTestId,
}: {
  isModalOpen: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  title: React.ReactNode;
  description?: string;
  confirmClose?: boolean;
  className?: string;
  dialogClassName?: string;
  dataTestId?: string;
}) {
  return (
    <Dialog
      open={isModalOpen}
      onClose={() => {
        if (!confirmClose) {
          onClose();
          return;
        }

        const response = confirm(
          "Voulez-vous vraiment fermer cet écran ? Toutes les données non enregistrées seront perdues."
        );

        if (response) {
          onClose();
        }
      }}
      className={cn("relative z-[200]", dialogClassName)}
    >
      <DialogBackdrop className="fixed inset-0 bg-black/50" />
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2 }}
        className="fixed inset-0 flex w-screen items-center justify-center p-4"
      >
        <DialogPanel
          className={cn(
            "space-y-4 bg-dark border border-input p-8 rounded-lg text-primary max-h-[100vh] overflow-y-auto custom-scrollbar",
            className
          )}
          data-testid={dataTestId}
        >
          <div className="flex flex-col gap-2">
            <DialogTitle className="font-bold text-xl flex justify-between">
              {title}
              <XMarkIcon
                className="w-4 h-4 cursor-pointer hover:text-secondary"
                onClick={onClose}
              />
            </DialogTitle>

            {description ? (
              <p className="text-sm text-secondary">{description}</p>
            ) : null}
          </div>

          {children}
        </DialogPanel>
      </motion.div>
    </Dialog>
  );
}
